<div class="mat-dialog-header">
  <div class="mat-dialog-title">Overdue Actions</div>
  <fa-icon (click)="handleClose()" [icon]="['fas', 'close']"></fa-icon>
</div>
<div mat-dialog-content>
  <div class="overdue-actions-content">
    <div class="student-card">
      <div class="first-column">
        <app-student-profile-photo
          [selectedImage]="student.profilePhotoUrl"
          [studentId]="student.id"
          [hideProfileImageSelector]="true"
          [imageWidth]="50"
          [imageHeight]="50">
        </app-student-profile-photo>
        <div class="student-name">
          <h4>{{student.firstName}} {{student.lastName}}</h4>
        </div>
      </div>
      <div class="second-column">
        <div >
          <h4><span class="hightlight">ID:</span> {{student.id}}</h4>
        </div>
        <div>
          <h4><span class="hightlight">Grade:</span> {{student.grade}}</h4>
        </div>
      </div>
    </div>
    <div *ngFor="let overdueReaction of overdueReactions" class="overdue-reaction">
      <h4>Overdue Action: <span class="hightlight">{{ overdueReaction.reactionName }}</span></h4>
      <div class="reaction-pop">
        This student has an outstanding action, overdue on <span>{{ overdueReaction.reactionDate ?? overdueReaction.date | date }}</span>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end" class="modal-dialog-actions">
  <button
    mat-flat-button
    mat-dialog-close
    class="action-button"
  >
    Cancel Check-in
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="checkInOutStudent()"
  >
    Complete Check-in
  </button>
</div>